import React from "react";
import { useState } from "react";
import useIsMobile from "../../../js/utilities/useIsMobile";
import { useEffect } from "react";
import { FOOTER_CONTACTS } from "../data/contacts";
import { Icon } from "@iconify/react";
import * as _ from "lodash";
import { useTranslations } from "../../../hooks/use-translations";
import { useLanguage } from "../../../hooks/use-language";
import { useId } from "../../../hooks/use-id";
/**
 * Componente de la lista de contactos en el footer.
 * @returns {JSX.Element} Componente ContactList.
 */
export const ContactList = () => {
	const contactList = [...FOOTER_CONTACTS];
	return (
		<div className="contact-section row p-0 m-0 pb-3">
			{contactList?.map((contactData, i) => {
				return (
					<div key={i} className="col-12 col-lg-6 col-xl-6 p-0">
						<ContactCard key={i} data={contactData} />
					</div>
				);
			})}
		</div>
	);
};

/**
 * Componente de una tarjeta de contacto en el footer.
 * @param {object} props 
 * @param {object} props.data 
 * @param {string} props.data.title 
 * @param {string} props.data.title.translationPath 
 * @param {string} props.data.title.default 
 * @param {object} props.data.emails 
 * @param {string} props.data.emails.contactName 
 * @param {string} props.data.emails.email 
 * @param {string} props.data.emails.website 
 * @param {object} props.data.contactNumbers 
 * @param {string} props.data.contactNumbers 
 * @param {object} props.data.adresses 
 * @param {string} props.data.adresses 
 * @returns {JSX.Element} Componente ContactCard.
 */
export const ContactCard = ({ data }) => {
	const lang = useLanguage();
	const texts = useTranslations({ section: "footer", lang: lang });
	const [expanded, setExpanded] = useState(false);
	const isMobile = useIsMobile();

	const title = _.get(texts, data?.title?.translationPath) || data?.title?.default || "N/A";
	const emails = Array.isArray(data?.emails) ? data?.emails : [];
	const contactNumbers = Array.isArray(data?.contactNumbers) ? data?.contactNumbers : [];
	const adresses = Array.isArray(data?.adresses) ? data?.adresses : [];
	const defaultTitle = data?.title?.default || "N/A";
	const contactId = useId(`contact-info-${defaultTitle}`)

	useEffect(() => {
		if (isMobile === false) {
			setExpanded(true);
		} else {
			setExpanded(false);
		}
	}, [isMobile]);

	const handleMobileExpandedState = (_expanded) => {
		if (isMobile) {
			setExpanded(_expanded);
		}
	};

	return (
		<div className="contact-card p-2">
			<h3 className="title justify-content-between d-none d-lg-flex">
				<span>{title}</span>
			</h3>
			<button
				className="w-100 section-subtitle d-flex justify-content-between d-lg-none focusable-secondary"
				onClick={() => handleMobileExpandedState(!expanded)}
				aria-expanded={expanded}
				aria-controls={contactId}
			>
				<span>{title}</span>

				<Icon
					className={`dropdown-arrow-transition d-lg-none ${expanded ? "expanded-dropdown" : "collapsed-dropdown"}`}
					icon="fe:arrow-down"
					width={"1.5em"}
				/>
			</button>
			<h4 className="sr-only">{texts?.listas?.correos || "Lista de correos electrónicos"}</h4>
			<div className={`info ${expanded ? "d-block" : "d-none"}`} style={{ maxWidth: 300 }} id={contactId}>
				<ul className={`my-2`}>
					{emails?.map((email, i) => {
						return (
							<li key={i}>
								{email?.website ? (
									<a
										className="info font-weight-bold default-link d-block focusable-secondary"
										href={email.website}
										target="_blank"
										rel="noopener noreferrer"
										aria-label={`${texts?.listas?.enviar_correo || "Enviar correo a"} ${email?.contactName}`}
									>
										{email?.contactName}
									</a>
								) : (
									<p className="info font-weight-bold">{email?.contactName}</p>
								)}
								<a
									className="info font-weight-bold default-link focusable-secondary"
									href={`mailto:${email?.email}`}
									aria-label={`${texts?.listas?.enviar_correo || "Enviar correo a"} ${email?.email}`}
								>
									{email?.email}
								</a>
							</li>
						);
					})}
				</ul>
				<h4 className="sr-only">{texts?.listas?.telefonos || "Lista de números de teléfono"}</h4>
				<ul className="my-2">
					{contactNumbers?.map((contact, i) => {
						return (
							<li key={i}>
								<p className="">{contact}</p>
							</li>
						);
					})}
				</ul>
				<h4 className="sr-only">{texts?.listas?.direcciones || "lista de direcciones"}</h4>
				<ul className="my-2">
					{adresses?.map((adress, i) => {
						return (
							<li key={i}>
								<p className="info font-weight-normal">{adress}</p>
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
};
